import React, { useRef, useState } from "react";
import uploadImageToServer from "./utils/uploadImageToServer";


const MAX_SIZE = 5 * 1024 * 1024;

export default function SignatureForm({ signatures = {}, setSignatures }) {
  const inputRef = useRef(null);
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e, role) => {
    setError("");
    const file = e.target.files[0];
    if (!file) return;
    if (!/^image\//.test(file.type)) {
      setError("Only image files are allowed.");
      return;
    }
    if (file.size > MAX_SIZE) {
      setError("Signature must be under 5MB.");
      return;
    }
    setUploading(true);
    try {
      const { url } = await uploadImageToServer(file, "signature");
      setSignatures(prev => ({
        ...prev,
        [role]: url
      }));
    } catch (err) {
      setError("Upload failed: " + err.message);
    }
    setUploading(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const roles = [
    { key: "assessor", label: "Assessor Signature" },
    { key: "validator", label: "Validator Signature" },
    { key: "client", label: "Client Signature" }
  ];

  return (
    <fieldset className="fra-fieldset p-4 border rounded-lg mb-6">
      <legend className="font-semibold text-lg mb-2">Signatures</legend>
      {error && <div className="text-red-600 mb-2 text-sm">{error}</div>}
      {roles.map(role => (
        <div key={role.key} className="mb-3">
          <label className="block mb-1 font-medium">{role.label}</label>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={e => handleChange(e, role.key)}
            className="mb-1"
            disabled={uploading}
          />
          {signatures[role.key] && (
            <img
              src={
                signatures[role.key].startsWith("http") || signatures[role.key].startsWith("/")
                  ? `https://regulatoryreformfiresafety.seitechinternational.com${signatures[role.key]}`
                  : signatures[role.key]
              }
              alt={`${role.label}`}
              className="h-14 border rounded shadow bg-white"
              style={{ marginTop: 4 }}
            />
          )}
        </div>
      ))}
      {uploading && (
        <div className="text-blue-500 mt-2 text-sm">Uploading...</div>
      )}
    </fieldset>
  );
}
